import ErrMsgsProvider, { useErrMsgsState } from './Provider';

export default ErrMsgsProvider;
export { useErrMsgsState };
